/* ------------------------------------------------------
1. Routine Mapping
Glow, Pigmentation,  Anti-aging, Acne, Dryness/dehydration
------------------------------------------------------ */

const routineMapping = {
    oily: {
      concerns: ["glow","pigmentation","ageing","acne"], // Dynamic dropdown
      routines: {
        acne: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "hyphen-clarifying-acne-cleanser",
              info: "Washes away excess oil and acne-causing impurities.",
              ingredients: "Salicylic Acid",
              ingredientInfo: [
                "Gently exfoliates skin",
                "Unclogs pores",
                "Removes impurities"               
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "acne-defence-daily-serum",
              info: "Treats active acne, soothes and calms skin, prevents future breakouts",
              ingredients: "Azelaic Acid",
              ingredientInfo: [
                "Helps prevent future breakouts",
                "Kills acne causing bacteria",
                "Improves skin texture"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Pat 1-2 pumps of serum.",
                "Apply on face and neck.",
                "Pat until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "ultra-light-water-sunscreen-spf-50-pa",
              info: "New Age UV filters for advanced sun protection.",
              ingredients: "1% Hyaluronic Acid",
              ingredientInfo: [
                "Hydrates skin deeply"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        ageing: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "oil-control-daily-exfoliating-cleanser-gently-exfoliates-makes-skin-oil-free-100-ml",
              info: "Gently exfoliates, removes impurities.",
              ingredients: "AHA-BHA",
              ingredientInfo: [
                "Gently Exfoliates"              
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "0-05-retinal-reset-serum-beginner-friendly",
              info: "Minimizes signs of ageing More effective than Retinol",
              ingredients: "Encapsulated Retinal",
              ingredientInfo: [
                "Promotes cell regeneration",
                "Reduces fine lines, wrinkles"
              ],
              recomdLine: "",
              frequency: "PM",
              howToUse: [
                "Apply 1-2 pumps on cleansed skin.",
                "Start with using twice a week.",
                "Use moisturizer after.",
                "Use SPF next day in the morning"
              ]
            },
            Moisturizer: {
              productHandle: "barrier-care-cream-oily-skin",
              info: "To moisturize and soothe skin",
              ingredients: "2% Ceramide-Peptide Complex",
              ingredientInfo: [
                "Repairs & Strengthens skin barrier"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pumps and apply evenly on face and neck."
              ]
            },
            Sunscreen: {
              productHandle: "ultra-light-water-sunscreen-spf-50-pa",
              info: "New Age UV filters for advanced sun protection",
              ingredients: "1% Hyaluronic Acid",
              ingredientInfo: [
                "Hydrates skin deeply"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        glow: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "44-rice-water-brightening-serum-pads",
              info: "Visibly fades dark spots, for brighter and glowing skin",
              ingredients: "Rice Water",
              ingredientInfo: [
                "Brightens and soothes skin"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take a serum pad.",
                "Gently swipe across face."
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "ultra-light-water-sunscreen-spf-50-pa",
              info: "New Age UV filters for advanced sun protection",
              ingredients: "1% Hyaluronic Acid",
              ingredientInfo: [
                "Hydrates skin deeply"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        pigmentation: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "oil-control-daily-exfoliating-cleanser-gently-exfoliates-makes-skin-oil-free-100-ml",
              info: "Gently exfoliates, removes impurities.",
              ingredients: "AHA-BHA",
              ingredientInfo: [
                "Gently Exfoliates"              
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "advanced-de-pigmentation-serum",
              info: "Visibly fades dark spots, for brighter and glowing skin",
              ingredients: "3% Tranexamic Acid",
              ingredientInfo: [
                "Helps fade dark spots"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Pat 1-2 pumps on cleansed face"
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "vitamin-infused-brightening-sunscreen-spf-50-pa",
              info: "Sun protection, while making skin brighter",
              ingredients: "1% Vitamin E + Vitamin C",
              ingredientInfo: [
                "Protects skin,makes it brighter"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        }
      }
    },
    dry: {
      concerns: ["glow","pigmentation","ageing","acne","dryness"],
      routines: {
        acne: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "hyphen-clarifying-acne-cleanser",
              info: "Washes away excess oil and acne-causing impurities.",
              ingredients: "Salicylic Acid",
              ingredientInfo: [
                "Gently exfoliates skin",
                "Unclogs pores",
                "Removes impurities"               
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "acne-defence-daily-serum",
              info: "Treats active acne, soothes and calms skin, prevents future breakouts",
              ingredients: "Azelaic Acid",
              ingredientInfo: [
                "Helps prevent future breakouts",
                "Kills acne causing bacteria",
                "Improves skin texture"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Pat 1-2 pumps of serum.",
                "Apply on face and neck.",
                "Pat until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "sun-milk-100-mineral-sunscreen-spf-50-pa",
              info: "Provides UV protection without generating heat on skin.",
              ingredients: "Nano-Zinc Oxide",
              ingredientInfo: [
                "Broad spectrum UV protection"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        dryness: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "moisturizing-creamy-cleanser-mildly-cleanses-non-drying-100ml",
              info: "Mildly cleanses, maintains skin's pH balance",
              ingredients: "Ceramides",
              ingredientInfo: [
                "Nourishes"                               
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "hydrating-ceramide-toner-essence",
              info: "Instant hydration, that repairs skin barrier",
              ingredients: "NMF + 5 essential ceramides",
              ingredientInfo: [
                "Deeply hydrates skin",
                "Repairs skin barrier"              
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take a generous amount, pat until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "ceramide-rich-pillow-cream",
              info: "Provide rich intense moisturization to dry skin.",
              ingredients: "Ceramides+NMF",
              ingredientInfo: [
                "Improve skin barrier function",
                "Help in retaining moisture"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take a little amount and apply on skin after serum."
              ]
            },
            Sunscreen: {
              productHandle: "all-i-need-sunscreen-spf-50",
              info: "Brightens and protects skin",
              ingredients: "Kojic Acid",
              ingredientInfo: [
                "Reduces dark spots"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        ageing: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "moisturizing-creamy-cleanser-mildly-cleanses-non-drying-100ml",
              info: "Mildly cleanses, maintains skin's pH balance.",
              ingredients: "Ceramides",
              ingredientInfo: [
                "Nourishes"              
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "0-05-retinal-reset-serum-beginner-friendly",
              info: "Minimizes signs of ageing More effective than Retinol",
              ingredients: "Encapsulated Retinal",
              ingredientInfo: [
                "Promotes cell regeneration",
                "Reduces fine lines, wrinkles"
              ],
              recomdLine: "",
              frequency: "PM",
              howToUse: [
                "Apply 1-2 pumps on cleansed skin.",
                "Start with using twice a week.",
                "Use moisturizer after.",
                "Use SPF next day in the morning"
              ]
            },
            Moisturizer: {
              productHandle: "barrier-care-cream-oily-skin",
              info: "To moisturize and soothe skin",
              ingredients: "2% Ceramide-Peptide Complex",
              ingredientInfo: [
                "Repairs & Strengthens skin barrier"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pumps and apply evenly on face and neck."
              ]
            },
            Sunscreen: {
              productHandle: "all-i-need-sunscreen-spf-50",
              info: "Brightens and protects skin",
              ingredients: "Kojic Acid",
              ingredientInfo: [
                "Reduces dark spots"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        glow: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "golden-hour-glow-face-serum",
              info: "Reduce Dark Spots & Pigmentation",
              ingredients: "Niacinamide",
              ingredientInfo: [
                "Brightens Skin"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Apply 2-3 pumps on face & neck,massage until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "golden-hour-glow™-moisturizer",
              info: "Boosts radiance Protects from oxidative stress",
              ingredients: "Kakadu Plum",
              ingredientInfo: [
                "Brightens Skin",
                "Protects against environmental damage"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take a little amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "golden-hour-glow™-screen-spf-50-pa",
              info: "Protects against oxidative damage",
              ingredients: "Kakadu Plum",
              ingredientInfo: [
                "Brightens Skin",
                "Protects against environmental damage"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        pigmentation: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "double-shot-radiance-lift-serum",
              info: "Brightens skin & boosts natural collagen",
              ingredients: "18% Brightening + 20% Collagen",
              ingredientInfo: [
                "Brightens & Lifts"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Apply 2-3 pumps on face & neck,massage until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "barrier-care-cream-oily-skin",
              info: "To moisturize and soothe skin",
              ingredients: "2% Ceramide-Peptide Complex",
              ingredientInfo: [
                "Repairs & Strengthens skin barrier"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pumps and apply evenly on face and neck."
              ]
            },
            Sunscreen: {
              productHandle: "vitamin-infused-brightening-sunscreen-spf-50-pa",
              info: "Sun protection, while making skin brighter",
              ingredients: "1% Vitamin E + Vitamin C",
              ingredientInfo: [
                "Protects skin,makes it brighter"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        }
      }
    },
    combination: {
      concerns: ["glow","pigmentation","ageing","acne","dryness"],
      routines: {
        acne: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "hyphen-clarifying-acne-cleanser",
              info: "Washes away excess oil and acne-causing impurities.",
              ingredients: "Salicylic Acid",
              ingredientInfo: [
                "Gently exfoliates skin",
                "Unclogs pores",
                "Removes impurities"               
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "acne-defence-daily-serum",
              info: "Treats active acne, soothes and calms skin, prevents future breakouts",
              ingredients: "Azelaic Acid",
              ingredientInfo: [
                "Helps prevent future breakouts",
                "Kills acne causing bacteria",
                "Improves skin texture"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Pat 1-2 pumps of serum.",
                "Apply on face and neck.",
                "Pat until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "ultra-light-water-sunscreen-spf-50-pa",
              info: "New Age UV filters for advanced sun protection.",
              ingredients: "1% Hyaluronic Acid",
              ingredientInfo: [
                "Hydrates skin deeply"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        dryness: {
          steps: ["Cleanser","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "moisturizing-creamy-cleanser-mildly-cleanses-non-drying-100ml",
              info: "Mildly cleanses, maintains skin's pH balance",
              ingredients: "Ceramides",
              ingredientInfo: [
                "Nourishes"                               
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Moisturizer: {
              productHandle: "barrier-care-cream-oily-skin",
              info: "To moisturize and soothe skin",
              ingredients: "2% Ceramide-Peptide Complex",
              ingredientInfo: [
                "Repairs & Strengthens skin barrier"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pumps and apply evenly on face and neck."
              ]
            },
            Sunscreen: {
              productHandle: "ultra-light-water-sunscreen-spf-50-pa",
              info: "New Age UV filters for advanced sun protection",
              ingredients: "1% Hyaluronic Acid",
              ingredientInfo: [
                "Hydrates skin deeply"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        ageing: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "0-05-retinal-reset-serum-beginner-friendly",
              info: "Minimizes signs of ageing More effective than Retinol",
              ingredients: "Encapsulated Retinal",
              ingredientInfo: [
                "Promotes cell regeneration",
                "Reduces fine lines, wrinkles"
              ],
              recomdLine: "",
              frequency: "PM",
              howToUse: [
                "Apply 1-2 pumps on cleansed skin.",
                "Start with using twice a week.",
                "Use moisturizer after.",
                "Use SPF next day in the morning"
              ]
            },
            Moisturizer: {
              productHandle: "barrier-care-cream-oily-skin",
              info: "To moisturize and soothe skin",
              ingredients: "2% Ceramide-Peptide Complex",
              ingredientInfo: [
                "Repairs & Strengthens skin barrier"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pumps and apply evenly on face and neck."
              ]
            },
            Sunscreen: {
              productHandle: "vitamin-infused-brightening-sunscreen-spf-50-pa",
              info: "Sun protection, while making skin brighter",
              ingredients: "1% Vitamin E + Vitamin C",
              ingredientInfo: [
                "Protects skin,makes it brighter"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        glow: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "golden-hour-glow-face-serum",
              info: "Reduce Dark Spots & Pigmentation",
              ingredients: "Niacinamide",
              ingredientInfo: [
                "Brightens Skin"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Apply 2-3 pumps on face & neck,massage until absorbed."
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "golden-hour-glow™-screen-spf-50-pa",
              info: "Protects against oxidative damage",
              ingredients: "Kakadu Plum",
              ingredientInfo: [
                "Brightens Skin",
                "Protects against environmental damage"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        },
        pigmentation: {
          steps: ["Cleanser","Serum","Moisturizer","Sunscreen"],
          products: {
            Cleanser: {
              productHandle: "rice-water-brightening-daily-cleanser",
              info: "Removes impurities for a healthy glow.",
              ingredients: "Fermented Rice Water",
              ingredientInfo: [
                "Even-tones skin",
                "Makes it clearer with use",
                "Enhances glow"           
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Take pump size amount",
                "Massage gently for 30 seconds on wet skin",
                "Rinse thoroughly and pat dry"
              ]
            },
            Serum: {
              productHandle: "advanced-de-pigmentation-serum",
              info: "Visibly fades dark spots, for brighter and glowing skin",
              ingredients: "3% Tranexamic Acid",
              ingredientInfo: [
                "Helps fade dark spots"
              ],
              recomdLine: "",
              frequency: "Daily",
              howToUse: [
                "Pat 1-2 pumps on cleansed face"
              ]
            },
            Moisturizer: {
              productHandle: "oil-free-moisturizer",
              info: "Gives lightweight hydration Doesn't clog pores",
              ingredients: "Cica Exosomes",
              ingredientInfo: [
                "Gives deep cellular level hydration"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 pea sized amount and apply on skin after serum.",
                "Use sunscreen after, in AM"
              ]
            },
            Sunscreen: {
              productHandle: "vitamin-infused-brightening-sunscreen-spf-50-pa",
              info: "Sun protection, while making skin brighter",
              ingredients: "1% Vitamin E + Vitamin C",
              ingredientInfo: [
                "Protects skin,makes it brighter"
              ],
              recomdLine: "",
              frequency: "AM",
              howToUse: [
                "Take 1-2 finger length sunscreen.",
                "Apply on face & neck.",
                "Use 15 mins before sun exposure"
              ]
            }
          }
        }
      }
    }
  };